// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd // // This program
is licensed under the terms of the GNU AGPL v3, or // alternatively under a
commercial licence. // // The terms of the AGPL v3 license can be found in the
main directory of this // repository.

<template>
  <v-app>
    <v-navigation-drawer v-model="nav" app stateless width="300">
      <v-layout column fill-height>
        <v-list dense>
          <template v-for="(item, i) in menuItems">
            <v-subheader v-if="item.header" v-text="item.header" class="grey--text text--darken-1" :key="i" />
            <v-divider class="divider_menu" v-else-if="item.divider" :key="i" />
            <v-list-item v-else-if="item.switch" @click.stop="toggleStoreValue(item.store_var_name)" :key="i">
              <v-list-item-action>
                <v-switch value :input-value="getStoreValue(item.store_var_name)" label=""></v-switch>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template v-else>
              <v-list-item v-if="item.link" target="_blank" rel="noopener" :href="item.link" :key="i">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.title" />
                <v-icon disabled>mdi-open-in-new</v-icon>
              </v-list-item>
              <v-list-item v-else-if="item.footer === undefined" @click.stop="toggleStoreValue(item.store_var_name)"
                :key="i">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.title" />
              </v-list-item>
            </template>
          </template>
        </v-list>
        <template v-for="(item, i) in menuComponents">
          <component :is="item" :key="i"></component>
        </template>
        <v-spacer></v-spacer>
        <v-list dense>
          <v-divider class="divider_menu" />
          <template v-for="(item, i) in menuItems">
            <v-list-item v-if="item.footer" @click.stop="toggleStoreValue(item.store_var_name)" :key="i">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title" />
            </v-list-item>
          </template>
        </v-list>
      </v-layout>
    </v-navigation-drawer>

    <v-main>
      <v-container class="fill-height" fluid style="padding: 0">
        <div id="stel" v-bind:class="{ right_panel: $store.state.showSidePanel }">
          <div style="position: relative; width: 100%; height: 100%">
            <component v-bind:is="guiComponent"></component>
            <canvas id="stel-canvas" ref="stelCanvas"></canvas>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import _ from "lodash";
import Gui from "@/components/gui.vue";
import GuiLoader from "@/components/gui-loader-new.vue";
import swh from "@/assets/sw_helpers.js";
import Moment from "moment";

export default {
  data(context) {
    return {
      menuItems: [
        {
          title: this.$t("View Settings"),
          icon: "mdi-settings",
          store_var_name: "showViewSettingsDialog",
        },
        {
          title: this.$t("Planets Tonight"),
          icon: "mdi-panorama-fisheye",
          store_var_name: "showPlanetsVisibilityDialog",
        },
        { divider: true },
      ]
        .concat(this.getPluginsMenuItems())
        .concat([
          {
            title: this.$t("Data Credits"),
            footer: true,
            icon: "mdi-copyright",
            store_var_name: "showDataCreditsDialog",
          },
        ]),
      menuComponents: [].concat(this.getPluginsMenuComponents()),
      guiComponent: "GuiLoader",
      startTimeIsSet: false,
      initDone: false,
      timeRef: undefined,
      dataSourceInitDone: false,
    };
  },
  components: { Gui, GuiLoader },
  methods: {
    changeLocation: function (lng, lat, alt) {
      const that = this;
      // alert('09999')
      if (lng && lat) {
        const pos = {
          lat: Number(lat),
          lng: Number(lng),
          alt: alt ? Number(alt) : 0,
          accuracy: 1,
        };
        swh.geoCodePosition(pos, that).then(
          (loc) => {
            that.$store.commit("setCurrentLocation", loc);
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    changeTime: function (timeStr) {
      const that = this;
      that.$stel.core.observer.utc = new Date(timeStr).getMJD();
    },
    // changeDevice: function (x, y ,z) {
    //   let that = this
    //   that.$stel.core.observer.yaw = x * Math.PI / 180
    //   that.$stel.core.observer.pitch = y * Math.PI / 180
    //   that.$stel.core.observer.roll = z * Math.PI / 180
    // },
    changeFov: function (fov) {
      const that = this;
      that.$stel.core.fov = (fov * Math.PI) / 180;
    },
    changeObject: function (passName) {
      const that = this;
      const name = decodeURIComponent(passName);
      console.log("Will select object: " + name);
      return swh.lookupSkySourceByName(name).then(
        (ss) => {
          console.log(ss);
          if (!ss) {
            return;
          }
          let obj = swh.skySource2SweObj(ss);
          if (!obj) {
            obj = that.$stel.createObj(ss.model, ss);
            that.$selectionLayer.add(obj);
          }
          if (!obj) {
            console.warning("Can't find object in SWE: " + ss.names[0]);
          }
          console.log(obj);
          swh.setSweObjAsSelection(obj);
        },
        (err) => {
          console.log(err);
          console.log("Couldn't find skysource for name: " + name);
        }
      );
    },
    getPluginsMenuItems: function () {
      let res = [];
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i];
        if (plugin.menuItems) {
          res = res.concat(plugin.menuItems);
        }
      }
      return res;
    },
    getPluginsMenuComponents: function () {
      let res = [];
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i];
        if (plugin.menuComponents) {
          res = res.concat(plugin.menuComponents);
        }
      }
      return res;
    },
    toggleStoreValue: function (storeVarName) {
      this.$store.commit("toggleBool", storeVarName);
    },
    getStoreValue: function (storeVarName) {
      return _.get(this.$store.state, storeVarName);
    },
    onBeforeRendering: function (timestamp) {
      if (!this.timeRef) this.timeRef = new Date().getMJD();
      const d = new Date().getMJD();
      this.$stel.observer.utc +=
        this.$store.state.timeSpeed * (d - this.timeRef);
      this.timeRef = d;
    },
    setStateFromQueryArgs: function () {
      // Check whether the observing panel must be displayed
      this.$store.commit("setValue", {
        varName: "showSidePanel",
        newValue: this.$route.path.startsWith("/p/"),
      });

      // Set the core's state from URL query arguments such
      // as date, location, view direction & fov
      var that = this;

      if (!this.initDone) {
        this.$stel.core.time_speed = 1;

        let d = new Date();

        if (this.$route.query.date) {
          d = new Moment(this.$route.query.date).toDate();
          this.$stel.core.observer.utc = d.getMJD();
          this.startTimeIsSet = true;
        }

        if (this.$route.query.lng && this.$route.query.lat) {
          const pos = {
            lat: Number(this.$route.query.lat),
            lng: Number(this.$route.query.lng),
            alt: this.$route.query.elev ? Number(this.$route.query.elev) : 0,
            accuracy: 1,
          };
          swh.geoCodePosition(pos, that).then(
            (loc) => {
              that.$store.commit("setCurrentLocation", loc);
            },
            (error) => {
              console.log(error);
            }
          );
        }

        this.$stel.core.observer.yaw = this.$route.query.az
          ? (Number(this.$route.query.az) * Math.PI) / 180
          : 0;
        this.$stel.core.observer.pitch = this.$route.query.alt
          ? (Number(this.$route.query.alt) * Math.PI) / 180
          : (30 * Math.PI) / 180;
        this.$stel.core.fov = this.$route.query.fov
          ? (Number(this.$route.query.fov) * Math.PI) / 180
          : (72 * Math.PI) / 180;

        this.initDone = true;
      }

      if (this.$route.path.startsWith("/skysource/")) {
        const name = decodeURIComponent(this.$route.path.substring(11));
        console.log("Will select object: " + name);
        return swh.lookupSkySourceByName(name).then(
          (ss) => {
            if (!ss) {
              return;
            }
            let obj = swh.skySource2SweObj(ss);
            if (!obj) {
              obj = this.$stel.createObj(ss.model, ss);
              this.$selectionLayer.add(obj);
            }
            if (!obj) {
              console.warning("Can't find object in SWE: " + ss.names[0]);
            }
            swh.setSweObjAsSelection(obj);
          },
          (err) => {
            console.log(err);
            console.log("Couldn't find skysource for name: " + name);
          }
        );
      }
    },
  },
  computed: {
    nav: {
      get: function () {
        return this.$store.state.showNavigationDrawer;
      },
      set: function (v) {
        if (this.$store.state.showNavigationDrawer !== v) {
          this.$store.commit("toggleBool", "showNavigationDrawer");
        }
      },
    },
    storeCurrentLocation: function () {
      return this.$store.state.currentLocation;
    },
  },
  watch: {
    storeCurrentLocation: function (loc) {
      const DD2R = Math.PI / 180;
      this.$stel.core.observer.latitude = loc.lat * DD2R;
      this.$stel.core.observer.longitude = loc.lng * DD2R;
      this.$stel.core.observer.elevation = loc.alt;

      // At startup, we need to wait for the location to be set before deciding which
      // startup time to set so that it's night time.
      if (!this.startTimeIsSet) {
        // this.$stel.core.observer.utc = swh.getTimeAfterSunset(this.$stel)
        this.startTimeIsSet = true;
      }
      // Init of time and date is complete
      this.$store.commit("setValue", {
        varName: "initComplete",
        newValue: true,
      });
    },
    $route: function () {
      // react to route changes...
      this.setStateFromQueryArgs();
    },
  },
  destroyed() {
    // 在组件生命周期结束的时候销毁。
  },
  mounted: function () {
    var that = this;
    if (!that.$route.query.app && !that.$route.query.dev) {
      return; // 如果不是从app来，则跳出
    }
    // that.$store.commit('setShowPlanetsVisibilityDialog', false)//打开默认关闭行星可见度
    that.$store.commit("setShowLocationDialog", false); // 打开默认关闭搜索地址
    window.changeLocation = this.changeLocation;
    window.changeObject = this.changeObject;
    window.changeFov = this.changeFov;
    window.changeTime = this.changeTime;
    // window.changeDevice = this.changeDevice;
    for (const i in this.$stellariumWebPlugins()) {
      const plugin = this.$stellariumWebPlugins()[i];
      if (plugin.onAppMounted) {
        plugin.onAppMounted(that);
      }
    }
    // CSS 制定时间
    // https://sky.darkmap.cn/#/skysource/NORAD%2048274?fov=120.00&date=2022-10-21T10%3A57%3A15Z&lat=25.77&lng=119&elev=0&lang=zh_CN
    import("@/assets/js/stellarium-web-engine.wasm").then((f) => {
      console.log(f);
      // Initialize the StelWebEngine viewer singleton
      // After this call, the StelWebEngine state will always be available in vuex store
      // in the $store.stel object in a reactive way (useful for vue components).
      // To modify the state of the StelWebEngine, it's enough to call/set values directly on the $stel object
      try {
        swh.initStelWebEngine(
          that.$store,
          f.default,
          that.$refs.stelCanvas,
          function () {
            // Start auto location detection (even if we don't use it)
            swh
              .getGeolocation()
              .then((p) => swh.geoCodePosition(p, that))
              .then(
                (loc) => {
                  that.$store.commit("setAutoDetectedLocation", loc);
                },
                (error) => {
                  console.log(error);
                }
              );

            // that.$stel.setFont('regular', process.env.BASE_URL + 'fonts/NotoSansSC-Regular.otf', 1.38)
            // that.$stel.setFont('bold', process.env.BASE_URL + 'fonts/NotoSansSC-Bold.otf', 1.38)
            // that.$stel.setFont('regular', process.env.BASE_URL + 'fonts/Roboto-Regular.ttf', 1.38)
            // that.$stel.setFont('bold', process.env.BASE_URL + 'fonts/Roboto-Bold.ttf', 1.38)
            // that.$stel.setFont('regular', process.env.BASE_URL + 'fonts/HarmonyOS_Sans_SC_Regular.ttf', 1.38)
            // that.$stel.setFont('bold', process.env.BASE_URL + 'fonts/HarmonyOS_Sans_SC_Bold.ttf', 1.38)
            that.$stel.core.constellations.show_only_pointed = true;
            that.$stel.core.constellations.labels_visible = true;
            that.$stel.core.constellations.images_visible = true;
            that.$stel.core.constellations.lines_visible = true;

            console.log(that.$stel.core)
            that.$stel.core.comets.hints_mag_offset = 3 //彗星亮度增益

            that.setStateFromQueryArgs();
            that.guiComponent = "Gui";
            for (const i in that.$stellariumWebPlugins()) {
              const plugin = that.$stellariumWebPlugins()[i];
              if (plugin.onEngineReady) {
                plugin.onEngineReady(that);
              }
            }

            if (!that.dataSourceInitDone) {
              // Set all default data sources Request URL: https://api.noctuasky.com/api/v1/skysources/name/NAME%20Andromeda%20Galaxy
              // Request URL: https://stellarium.sfo2.cdn.digitaloceanspaces.com/surveys/dss/v1/Norder3/Dir0/Npix244.webp?v=5715
              // n.stars.addDataSource({url:t+"swe-data-packs/minimal/2020-09-01/minimal_2020-09-01_186e7ee2/stars",key:"minimal"}),
              // n.stars.addDataSource({url:t+"swe-data-packs/base/2020-09-01/base_2020-09-01_1aa210df/stars",key:"base"}),
              // n.stars.addDataSource({url:t+"swe-data-packs/extended/2020-03-11/extended_2020-03-11_26aa5ab8/stars",key:"extended"}),
              // n.stars.addDataSource({url:t+"surveys/gaia/v1",key:"gaia"}),n.landscapes.addDataSource({url:t+"landscapes/v1/guereins",key:"guereins"}),
              // n.milkyway.addDataSource({url:t+"surveys/milkyway/v1"}),
              // n.dss.addDataSource({url:t+"surveys/dss/v1"}),e.$route.query.sc){var a=e.$route.query.sc.substring(e.$route.query.sc.lastIndexOf("/")+1);n.skycultures.addDataSource({url:e.$route.query.sc,key:a}),n.skycultures.current_id=a}else n.skycultures.addDataSource({url:t+"skycultures/v3/western",key:"western"});
              const core = that.$stel.core;
              core.stars.addDataSource({
                url: process.env.BASE_URL + "skydata/stars",
              });
              // core.stars.addDataSource({
              //   url:
              //     process.env.VUE_APP_CDN_DARKMAP_CN +
              //     "swe-data-packs/minimal/2020-09-01/minimal_2020-09-01_186e7ee2/stars",
              //   key: "minimal",
              // });
              core.stars.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN +
                  "swe-data-packs/base/2020-09-01/base_2020-09-01_1aa210df/stars",
                key: "base",
              });
              core.stars.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN +
                  "swe-data-packs/extended/2020-03-11/extended_2020-03-11_26aa5ab8/stars",
                key: "extended",
              });
              core.stars.addDataSource({
                url: process.env.VUE_APP_CDN_DARKMAP_CN + "surveys/gaia/v1",
                key: "gaia",
              });
              // core.dss.addDataSource({
              //   url: process.env.VUE_APP_CDN_DARKMAP_CN + "surveys/dss/v1",
              // });

              core.dss.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/dss/v1",
              });
              // core.dss.addDataSource({
              //     url: "https://twt.matomotech.com/dss/v1",
              // });
              // core.skycultures.addDataSource({ url: process.env.BASE_URL + 'skydata/skycultures/belarusian', key: 'belarusian' })
              // Allow to specify a custom path for sky culture data
              if (that.$route.query.dev || that.$route.query.ver >= 10013) {
                // console.log(that.$route.query.dev)
                // swh.setSweObjAsSelection({swe_: 1,v: 5995064})
                that.$store.commit("setShowCompass", true);
              }
              if (that.$route.query.dev) {
                // that.changeObject('capella')// 设置观测天体
                console.log(that.$stel);
              }
              if (that.$route.query.sc) {
                const key = that.$route.query.sc.substring(
                  that.$route.query.sc.lastIndexOf("/") + 1
                );
                console.log(key, that.$route.query.sc);
                core.skycultures.addDataSource({
                  url: that.$route.query.sc,
                  key: key,
                });
                core.skycultures.current_id = key;
                // http://localhost:8080/#/?sc=https://raw.githubusercontent.com/Stellarium/stellarium-skycultures/master/chinese
              } else if (that.$route.query.lang === "zh_CN") {
                core.skycultures.addDataSource({
                  url:
                    process.env.BASE_URL +
                    "skydata/skycultures/chinese_contemporary",
                  key: "chinese_contemporary",
                });
                core.skycultures.current_id = "chinese_contemporary";

                // that.changeTime("2022/11/8 17:48:00")//设置观测时间
                // that.changeFov(5)//设置视野度数
                // core.pitch = 仰角*pi/180
                // core.yaw = 方位角*pi/180
                // core.roll = 手机倾斜*pi/180
                // const callback = function (res) {
                // let i=0;
                // setInterval(() => {
                //   that.changeDevice(i++)
                // }, 1000);
                // }
                // uni.onCompassChange(callback);
              } else {
                core.skycultures.addDataSource({
                  url: process.env.BASE_URL + "skydata/skycultures/western",
                  key: "western",
                });
                core.skycultures.current_id = "western";
                // console.log(that.$stel)
              }
              // core.skycultures.addDataSource({url:process.env.VUE_APP_CDN_DARKMAP_CN +"skycultures/v3/western",key:"western"})

              core.dsos.addDataSource({
                url: process.env.BASE_URL + "skydata/dso",
              });
              // core.dsos.addDataSource({ url:process.env.VUE_APP_CDN_DARKMAP_CN+'swe-data-packs/base/2020-09-01/base_2020-09-01_1aa210df/dso' })
              // core.dsos.addDataSource({
              //   url:
              //     process.env.VUE_APP_CDN_DARKMAP_CN +
              //     "swe-data-packs/extended/2020-03-11/extended_2020-03-11_26aa5ab8/dso",
              // });
              core.dsos.addDataSource({
                url:
                  process.env.BASE_URL + "skydata/surveys/dso/extended"
              });

              core.landscapes.addDataSource({
                url: process.env.BASE_URL + "skydata/landscapes/guereins",
                key: "guereins",
              });

              core.milkyway.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/milkyway",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/moon",
                key: "moon",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/sun",
                key: "sun",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/jupiter",
                key: "jupiter",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/saturn",
                key: "saturn",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/mercury",
                key: "mercury",
              });
              // core.planets.addDataSource({ url:process.env.VUE_APP_CDN_DARKMAP_CN+'surveys/sso/saturn/v1', key: 'saturn' })
              core.planets.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN +
                  "surveys/sso/callisto/v1",
                key: "callisto",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/default",
                key: "default",
              });
              core.planets.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN + "surveys/sso/europa/v1",
                key: "europa",
              });
              core.planets.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN +
                  "surveys/sso/ganymede/v1",
                key: "ganymede",
              });
              core.planets.addDataSource({
                url: process.env.VUE_APP_CDN_DARKMAP_CN + "surveys/sso/io/v1",
                key: "io",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/mars",
                key: "mars",
              });
              core.planets.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN +
                  "surveys/sso/moon-normal/v1",
                key: "moon-normal",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/neptune",
                key: "neptune",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/uranus",
                key: "uranus",
              });
              core.planets.addDataSource({
                url: process.env.BASE_URL + "skydata/surveys/sso/venus",
                key: "venus",
              });

              core.minor_planets.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN + "mpc/v1/mpcorb.dat",
                key: "mpc_asteroids",
              });
              // core.comets.addDataSource({ url: process.env.VUE_APP_CDN_DARKMAP_CN + 'mpc/v1/CometEls.txt?v=' + new Date().toDateString(), key: 'mpc_comets' })
              core.comets.addDataSource({
                url: "https://nodeapi.knockdream.com/skydata/CometEls.txt",
                key: "mpc_comets",
              });
              //  core.comets.addDataSource({ url: 'https://www.minorplanetcenter.net/iau/MPCORB/CometEls.txt', key: 'mpc_comets' })
              core.satellites.addDataSource({
                url:
                  process.env.VUE_APP_CDN_DARKMAP_CN +
                  "skysources/v1/tle_satellite.jsonl.gz?v=2019-09-16",
                key: "jsonl/sat",
              });
            }
          },
          that.onBeforeRendering
        );
      } catch (e) {
        this.$store.commit("setValue", {
          varName: "wasmSupport",
          newValue: false,
        });
      }
    });
  },
};
</script>

<style>
a {
  color: #82b1ff;
}

a:link {
  text-decoration-line: none;
}

.divider_menu {
  margin-top: 8px;
  margin-bottom: 8px;
}

html {
  overflow-y: visible;
}

html,
body,
#app {
  overflow-y: visible !important;
  overflow-x: visible;
  position: fixed !important;
  width: 100%;
  height: 100%;
  padding: 0 !important;
  font-size: 14px;
}

.fullscreen {
  overflow-y: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 0 !important;
}

.click-through {
  pointer-events: none;
}

.get-click {
  pointer-events: all;
}

.dialog {
  background: transparent;
}

.menu__content {
  background-color: transparent !important;
}

#stel {
  height: 100%;
  width: 100%;
  position: absolute;
}

#stel-canvas {
  z-index: -10;
  width: 100%;
  height: 100%;
}

.right_panel {
  padding-right: 400px;
}

.v-btn {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 6px;
  margin-bottom: 6px;
}

.v-application--wrap {
  min-height: 100% !important;
}
</style>
